import { render, staticRenderFns } from "./Warnings.vue?vue&type=template&id=7ecada96&scoped=true&"
import script from "./Warnings.vue?vue&type=script&lang=js&"
export * from "./Warnings.vue?vue&type=script&lang=js&"
import style0 from "./Warnings.vue?vue&type=style&index=0&id=7ecada96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecada96",
  null
  
)

export default component.exports